const ADMIN_SESSION_KEY = "extronnect_admin";

export function isAdminAuthenticated() {
  return sessionStorage.getItem(ADMIN_SESSION_KEY) === "1";
}

export function loginAdmin(email, password) {
  const expectedEmail = process.env.REACT_APP_ADMIN_EMAIL;
  const expectedPassword = process.env.REACT_APP_ADMIN_PASSWORD;

  if (!expectedEmail || !expectedPassword) {
    return false;
  }

  if (email === expectedEmail && password === expectedPassword) {
    sessionStorage.setItem(ADMIN_SESSION_KEY, "1");
    return true;
  }

  return false;
}

export function logoutAdmin() {
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
}
